import { Box, CircularProgress, Grid } from '@mui/material';
import { stripeLoaderSx } from './CommomSxs';

export const StripeLoader = () => {
  return (
    <Grid item xs={12}>
      <Box sx={stripeLoaderSx?.stripeLoaderBx}>
        <CircularProgress size={64} />
      </Box>
    </Grid>
  );
};
